import request from '../utils/request';

//基本信息
export function getInfo() {
  return request({
    url: '/frontAudience/info/baseInfo',
    method: 'get',
  });
}

// 提交信息
export function saveInfo(data) {
  return request({
    url: '/frontAudience/info/baseInfoSave',
    method: 'post',
    data: data,
  });
}

// 确认函信息
export function getConfirmation() {
  return request({
    url: '/frontAudience/info/confirmation',
    method: 'GET',
  });
}

// 调查问卷信息
export function getQuest() {
  return request({
    url: '/frontAudience/info/questionnaireDetails',
    method: 'GET',
  });
} 

// 提交调查问卷信息
export function submitQuest(data) {
  return request({
    url: '/frontAudience/info/questionnaireSubmission',
    method: 'post',
    data: data,
  });
}


// 修改密码
export function changePassword(data) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return request({
    url: '/frontAudience/info/changePassword',
    method: 'post',
    data: formData,
  });
}
